export default "__VITE_ASSET__bjzb4WbC__"